import { render, staticRenderFns } from "./CalculateSalaryList.vue?vue&type=template&id=638a206b&scoped=true&"
import script from "./CalculateSalaryList.vue?vue&type=script&lang=js&"
export * from "./CalculateSalaryList.vue?vue&type=script&lang=js&"
import style0 from "./CalculateSalaryList.vue?vue&type=style&index=0&id=638a206b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638a206b",
  null
  
)

component.options.__file = "CalculateSalaryList.vue"
export default component.exports